import { svg } from "config/svgStyles";

export const helpButton = ({ isMobile }) => ({
  display: "flex",
  flexDirection: "row",
  color: "primary",
  alignItems: "center",
  border: "none",
  cursor: "pointer",
  fontFamily: "body",
  fontWeight: "light",
  fontSize: isMobile ? "20px" : "30px",
  justifyContent: "center",
  lineHeight: "1",
  letterSpacing: "0.025em",
  whiteSpace: "nowrap",
  gap: "10px",

  svg: {
    height: isMobile ? "16px" : "18px",
    width: isMobile ? "16px" : "18px",

    ...svg("primary"),
  },
});
